
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyBarrelConeUp as ObiBuoyBarrelConeUpElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-barrel-cone-up.js';
 
 
 

 
 export const ObiBuoyBarrelConeUp = createComponent({
   react: React,
   tagName: 'obi-buoy-barrel-cone-up',
   elementClass: ObiBuoyBarrelConeUpElement,
   events: {
     
   }
  });
 
 